import { atom } from "recoil";

export const UserState = atom({
  key: "userState",
  default: {
    username: null,
    hasPasswordChanged: false,
    // hasQuestionSaved: false,
  },
});
